import React from 'react';
import { useTranslation } from 'react-i18next';
import {FaChalkboardTeacher, FaClipboardCheck, FaFlask, FaGraduationCap, FaPencilAlt, FaUsers} from 'react-icons/fa';
import './LessonTypeBadge.scss';

const lessonTypeConfig = {
    lecture: { icon: FaChalkboardTeacher, colorClass: 'lecture' },
    laboratory: { icon: FaFlask, colorClass: 'laboratory' },
    practical: { icon: FaPencilAlt, colorClass: 'practical' },
    seminar: { icon: FaUsers, colorClass: 'seminar' },
    exam:       { icon: FaGraduationCap, colorClass: 'exam' },
    credit:     { icon: FaClipboardCheck, colorClass: 'credit' },
};

const LessonTypeBadge = ({ lessonType, showIcon = true, size = 'normal', short = false }) => {
    const { t } = useTranslation('formElements');

    const type = lessonType?.toLowerCase() || '';
    const config = lessonTypeConfig[type] || { colorClass: 'default' };
    const Icon = config.icon;

    const label = short
        ? t(`lesson_type_${type}_short`, { defaultValue: lessonType })
        : t(`lesson_type_${type}_label`, { defaultValue: lessonType });

    return (
        <span
            className={`lesson-type-badge ${config.colorClass} lesson-type-badge--${size}`}
            title={short ? t(`lesson_type_${type}_label`, { defaultValue: lessonType }) : undefined}
        >
            {showIcon && Icon && <Icon className="lesson-type-badge__icon" />}
            {label}
        </span>
    );
};

export default LessonTypeBadge;